module.exports = __webpack_public_path__ + "static/media/Blood_pudding.08e261ea.png";